import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IHttpHeader } from "../models/http-header";
import { HttpMethodArgs } from "../shared/classes/http-method-args";
import { SM_CONSTANTS } from "../shared/constants/sm-constants";
import { throwError, Subject } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { StorageService } from "./storage.service";
import { StringDecoder } from "string_decoder";

export interface ApiResponse {
  result: any;
  responseType: string;
  otherData: any;
}
export interface ErrorResponse {
  error: any;
  message: string;
}

@Injectable({
  providedIn: "root",
})
export class ApiService {
  private _userServiceBaseUrl: string = environment.apiUserServiceBaseUrl;
  private _commonServiceBaseUrl: string = environment.apiCommonServiceBaseUrl;
  private _transactionServiceBaseUrl: string =
    environment.apiTransactionServiceBaseUrl;
  private _apiResult: Subject<ApiResponse> = new Subject<ApiResponse>();
  private _errorResponse: Subject<ErrorResponse> = new Subject<ErrorResponse>();
  private _socialServiceBaseUrl: string = environment.apiSocialServiceBaseUrl;

  private _uploadServiceBaseUrl: string = environment.apiUploadServiceBaseUrl;
  private _businessServiceBaseUrl: string =
    environment.apiBusinessServiceBaseUrl;
  private _adminServiceBaseUrl: string = environment.apiAdminServiceBaseUrl;
  private _fcmServiceBaseUrl: string = environment.apiFcmServiceBaseUrl;

  constructor(
    private _httpClient: HttpClient,
    private _storageService: StorageService,
  ) {}

  checkUser(
    bodyData: any,
    authId: string,
    phoneNumber: string,
    referralCode?: any,
  ) {
    const headerData: IHttpHeader[] = [
      { authID: authId },
      { phone: phoneNumber },
    ];

    if (
      referralCode !== undefined &&
      referralCode !== null &&
      referralCode !== ""
    ) {
      headerData.push({ referralCode: referralCode });
    }

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_CHECK_USER}`,
      SM_CONSTANTS.CHECK_USER_RESULT,
    );
    apiParam.body = bodyData;
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getAllUsers() {
    console.log(
      this._storageService.getLocalStorageValue(
        SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
      ),
    );

    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ALL_USERS}`,
      SM_CONSTANTS.GET_ALL_USERS_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  sendFcmNotificationOnTopic(topicInfo: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_SEND_FCM_NOTIFICATION_TO_TOPIC}`,
      SM_CONSTANTS.SEND_FCM_NOTIFICATION_TO_TOPIC_RESULT,
      topicInfo,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getTargetedNotificationsList() {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_TARGETED_NOTIFICATIONS}`,
      SM_CONSTANTS.GET_TARGETED_NOTIFICATIONS_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getContactMessages() {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_CONTACT_MESSAGES}`,
      SM_CONSTANTS.GET_CONTACT_MESSAGES_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getSubscriptionDetail(phoneNumber: string) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
      { phoneNo: phoneNumber },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_SUBSCRIPTION_DETAIL}`,
      SM_CONSTANTS.GET_SUBSCRIPTION_DETAIL_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getBusinessList(accountHash: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData: IHttpHeader[] = [
      {
        accountHashId: accountHash,
        currentDate: currentDate,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_BUSINESS_LIST}`,
      SM_CONSTANTS.GET_BUSINESS_LIST_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getBusinessDocs(entityHash: string) {
    const headerData: IHttpHeader[] = [
      {
        businessHashId: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_BUSINESS_DOCS_LIST}`,
      SM_CONSTANTS.GET_BUSINESS_DOCS_LIST_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getServiceTemplates(pageNo: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_SERVICE_TEMPLATES}` +
        "?count=25" +
        "&pageNo=" +
        pageNo,
      SM_CONSTANTS.GET_SERVICE_TEMPLATES_RESULT,
    );
    this.apiHandler(apiParam);
  }

  //search apis

  getServiceTemplateDataByKeyword(pageNo: any, searchKey: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_SERVICE_TEMPLATE_DATA_BY_KEYWORD}` +
        "?count=25" +
        "&pageNo=" +
        pageNo +
        "&searchKey=" +
        searchKey,
      SM_CONSTANTS.RESULT_API_GET_SERVICE_TEMPLATE_DATA_BY_KEYWORD,
    );
    this.apiHandler(apiParam);
  }
  getServiceDataByKeyword(entityHashId: any, pageNo: any, searchKey: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_SERVICE_DATA_BY_KEYWORD}` +
        "?count=25" +
        "&pageNo=" +
        pageNo +
        "&searchKey=" +
        searchKey +
        "&entityHashId=" +
        entityHashId +
        "&serviceType=0",
      SM_CONSTANTS.RESULT_API_GET_SERVICE_DATA_BY_KEYWORD,
    );
    this.apiHandler(apiParam);
  }
  getInventoryTemplateDataByKeyword(pageNo: any, searchKey: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_INVENTORY_TEMPLATE_DATA_BY_KEYWORD}` +
        "?count=25" +
        "&pageNo=" +
        pageNo +
        "&searchKey=" +
        searchKey,
      SM_CONSTANTS.RESULT_API_GET_INVENTORY_TEMPLATE_DATA_BY_KEYWORD,
    );
    this.apiHandler(apiParam);
  }
  getInventoryDataByKeyword(entityHashId: any, pageNo: any, searchKey: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_GET_INVENTORY_DATA_BY_KEYWORD}` +
        "?count=25" +
        "&pageNo=" +
        pageNo +
        "&searchKey=" +
        searchKey +
        "&entityHashId=" +
        entityHashId,
      SM_CONSTANTS.RESULT_API_GET_INVENTORY_DATA_BY_KEYWORD,
    );
    this.apiHandler(apiParam);
  }

  createAndUpdateCoupon(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_CREATE_DISCOUNT_COUPON_LIST}`,
      SM_CONSTANTS.CREATE_DISCOUNT_COUPON_RESULT,
    );
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  updateBusinessDocsStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_BUSINESS_DOCS_STATUS}`,
      SM_CONSTANTS.UPDATE_BUSINESS_DOCS_STATUS_RESULT,
    );
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  addUpdateServiceType(bodyData: any, entityHash: string) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_UPDATE_SERVICE_TYPE}`,
      SM_CONSTANTS.ADD_UPDATE_SERVICE_TYPE_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  addServiceTemplate(bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_SERVICE_TEMPLATES}`,
      SM_CONSTANTS.ADD_SERVICE_TEMPLATES_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  updateEntityInfo(bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENTITY_INFO}`,
      SM_CONSTANTS.UPDATE_ENTITY_INFO_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }
  deleteBusiness(bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENTITY_INFO}`,
      SM_CONSTANTS.DELETE_ENTITY_INFO_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  getUserRequest(status: number, resultType: string) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
      { requestStatus: status.toString() },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_USER_REQUEST}`,
      resultType,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getBuisnessPromotionListCount(onlyRecordCount: any = 1) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
      {
        onlyRecordCount: onlyRecordCount,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_BUISNESS_PROMOTION_LIST}`,
      SM_CONSTANTS.GET_BUISNESS_PROMOTION_LIST_COUNT_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getAdminPostListCount(onlyRecordCount: any = 1) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
      {
        onlyRecordCount: onlyRecordCount,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_GET_ADMIN_POST_LIST}`,
      SM_CONSTANTS.GET_ADMIN_POST_LIST_COUNT_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getDiscountCouponsListCount() {
    const headerData: IHttpHeader[] = [
      {
        discountType: "3",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_COUPONS_LIST}`,
      SM_CONSTANTS.GET_COUPONS_LIST_COUNT_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getDiscountCouponsList() {
    const headerData: any[] = [
      {
        entityHash: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH),
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        discountType: "3",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/v2/${SM_CONSTANTS.API_GET_COUPONS_LIST}`,
      SM_CONSTANTS.GET_COUPONS_LIST_RESULT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getBankInfo(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        businessHashId: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_BANK_INFO}`,
      SM_CONSTANTS.GET_BANK_INFO_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  updateBankInfo(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_BANK_INFO}`,
      SM_CONSTANTS.UPDATE_BANK_INFO_RESULT,
    );
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  getBuisnessPromotionList(pageNo: string, onlyRecordCount: string = "0") {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
      {
        pageNo: pageNo,
      },
      {
        noOfItems: "8",
      },
      {
        onlyRecordCount: onlyRecordCount,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_BUISNESS_PROMOTION_LIST}`,
      SM_CONSTANTS.GET_BUISNESS_PROMOTION_LIST_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  updateAdminPostInfo(postInfo: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ADMIN_POST_INFO}`,
      SM_CONSTANTS.UPDATE_ADMIN_POST_INFO_RESULT,
      postInfo,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getAdminPostInfoList(pageNo: string, onlyRecordCount: string = "0") {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
      {
        pageNo: pageNo,
      },
      {
        noOfItems: "8",
      },
      {
        onlyRecordCount: onlyRecordCount,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ADMIN_POST_LIST}`,
      SM_CONSTANTS.GET_ADMIN_POST_LIST_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  uploadAssets(bodyData: any, type: any) {
    // const headerData: IHttpHeader[] = [
    //   {
    //     'Content-Type': 'multipart/form-data',
    //   },
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._uploadServiceBaseUrl}/${SM_CONSTANTS.API_UPLOAD}?uploadType=${type}`,
      SM_CONSTANTS.UPLOAD_RESULT,
      bodyData,
    );
    // apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  updateBuisnessPromotion(bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_BUISNESS_PROMOTION_INFO}`,
      SM_CONSTANTS.UPDATE_BUISNESS_PROMOTION_INFO_RESULT,
      bodyData,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  updateUserRequestStatus(bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_USER_REQUEST_STATUS}`,
      SM_CONSTANTS.UPDATE_USER_REQUEST_STATUS_RESULT,
      bodyData,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getServices(entityHash: any, serviceType: any, pagenumber: any) {
    console.log(pagenumber);

    const headerData: IHttpHeader[] = [
      {
        entityHashId: localStorage.getItem(
          SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
        )!,
        pageNo: pagenumber,
        serviceType: serviceType,
        count: "25",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_SERVICE_TYPES_LIST}`,
      SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getServicesTypesList(entityHash: any, pagenumber: any, serviceType: any) {
    console.log(pagenumber);

    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHash,
        pageNo: pagenumber,
        serviceType: serviceType,
        count: "0",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_SERVICE_TYPES_LIST}`,
      SM_CONSTANTS.GET_SERVICES_TYPES_LIST_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getEntityDetails(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHash,
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        entityAssetType: "1",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_DETAILS}`,
      SM_CONSTANTS.GET_ENTITY_DETAILS_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getAllEntity() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ALL_ENTITY_DETAILS}`,
      SM_CONSTANTS.GET_ALL_ENTITY_DETAILS_RESULT,
    );

    this.apiHandler(apiParam);
  }

  getEntityAllServicePayments(businessHashId: any, fromDate: any, toDate: any) {
    const headerData: IHttpHeader[] = [
      {
        businessHashId: businessHashId,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_ALL_ENTITY_SERVICE_PAYMENTS}`,
      SM_CONSTANTS.GET_ALL_ENTITY_SERVICE_PAYMENTS_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getAllTransferredEntityPayment(
    businessHashId: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        businessHashId: businessHashId,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ALL_TRANSFERRED_ENTITY_PAYMENTS}`,
      SM_CONSTANTS.GET_ALL_TRANSFERRED_ENTITY_PAYMENT_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getBookingsList(entityHashId: any, fromDate: any, toDate: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHashId,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_BOOKINGS_LIST}`,
      SM_CONSTANTS.GET_BOOKINGS_LIST_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getUserDetail(accountHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: accountHashId,
        tokenType: "3",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_GET_USER_DETAIL}`,
      SM_CONSTANTS.GET_USER_DETAIL_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getUserDetailToSetCookie(accountHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: accountHashId,
        tokenType: "3",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_GET_USER_DETAIL}`,
      SM_CONSTANTS.GET_USER_DETAIL_RESULT_TO_SET_COOKIE,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getPostDetails(postHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        postHashId: postHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_GET_POST_DETAIL}`,
      SM_CONSTANTS.GET_POST_DETAIL_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  addContactMessages(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_CONTACT_MESSAGES}`,
      SM_CONSTANTS.ADD_CONTACT_MESSAGES_RESULT,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getCitySpecificData(country: any) {
    const headerData: IHttpHeader[] = [
      {
        country: country,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_CITY_SPECIFIC_DATA}`,
      SM_CONSTANTS.GET_CITY_SPECIFIC_DATA_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  blockUnblockOperation(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_BLOCK_UNBLOCK_OPERATION}`,
      SM_CONSTANTS.BLOCK_UNBLOCK_OPERATION_RESULT,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getReferral() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_REFERRAL_ACTIVITY}`,
      SM_CONSTANTS.GET_REFERRAL_ACTIVITY_RESULT,
    );

    this.apiHandler(apiParam);
  }

  updateReferralActivityStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_PUT,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_REFERRAL_ACTIVITY_STATUS}`,
      SM_CONSTANTS.UPDATE_REFERRAL_ACTIVITY_STATUS_RESULT,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getReferredUserDetails(accountId: any) {
    const headerData: IHttpHeader[] = [
      {
        accountId: accountId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_REFERRED_USER_DETAILS}`,
      SM_CONSTANTS.GET_REFERRED_USER_DETAILS_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getLatestBlockedUnblockedAccounts() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_LATEST_BLOCKED_UNBLOCKED_ACCOUNTS}`,
      SM_CONSTANTS.GET_LATEST_BLOCKED_UNBLOCKED_ACCOUNTS_RESULT,
    );

    this.apiHandler(apiParam);
  }

  addFreeSubscription(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_FREE_SUBSCRIPTION}`,
      SM_CONSTANTS.ADD_FREE_SUBSCRIPTION_RESULT,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getUnUsedQRCodes() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_UNUSED_QR_CODES}`,
      SM_CONSTANTS.GET_UNUSED_QR_CODES_RESULT,
    );

    this.apiHandler(apiParam);
  }
  getLinkedQRCodes() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_LINKED_QR_CODES}`,
      SM_CONSTANTS.GET_LINKED_QR_CODES_RESULT,
    );

    this.apiHandler(apiParam);
  }

  createQRcode() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_CREATE_QR_CODE}`,
      SM_CONSTANTS.CREATE_QR_CODE_RESULT,
    );

    this.apiHandler(apiParam);
  }

  getBookingQRCodes(businessHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        businessHashId: businessHashId,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_GET_BOOKING_QR_CODES}`,
      SM_CONSTANTS.GET_BOOKING_QR_CODES_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  linkQRCode(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_LINK_QR_CODE}`,
      SM_CONSTANTS.LINK_QR_CODE_RESULT,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  unlinkQRCode(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_UNLINK_QR_CODE}`,
      SM_CONSTANTS.UNLINK_QR_CODE_RESULT,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getCurrentStatistics() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_CURRENT_STATISTICS}`,
      SM_CONSTANTS.RESULT_API_GET_CURRENT_STATISTICS,
    );
    this.apiHandler(apiParam);
  }

  getAppDataSettings() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_APP_DATA_SETTINGS}`,
      SM_CONSTANTS.RESULT_API_GET_APP_DATA_SETTINGS,
    );
    this.apiHandler(apiParam);
  }

  addEditAppDataSettings(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_APP_DATA_SETTINGS}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_APP_DATA_SETTINGS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getAdvertisers() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ADVERTISERS}`,
      SM_CONSTANTS.RESULT_API_GET_ADVERTISERS,
    );
    this.apiHandler(apiParam);
  }

  getAdvertisersWithSearch(keyword: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ADVERTISERS}` +
        "?searchKey=" +
        keyword,
      SM_CONSTANTS.RESULT_API_GET_ADVERTISERS,
    );
    this.apiHandler(apiParam);
  }

  addEditAdvertiser(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ADVERTISERS}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ADVERTISERS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getPromotionalPostCampaigns(advertiserHashId: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ADVERTISERS_PROMOTIONAL_POST_CAMPAIGNS}` +
        "?advertiserHashId=" +
        advertiserHashId,
      SM_CONSTANTS.RESULT_API_GET_ADVERTISERS_PROMOTIONAL_POST_CAMPAIGNS,
    );
    this.apiHandler(apiParam);
  }
  getPromotionalBannerCampaigns(advertiserHashId: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ADVERTISERS_BANNER_CAMPAIGNS}` +
        "?advertiserHashId=" +
        advertiserHashId,
      SM_CONSTANTS.RESULT_API_GET_ADVERTISERS_BANNER_CAMPAIGNS,
    );
    this.apiHandler(apiParam);
  }
  getPromotionNotificationCampaigns(advertiserHashId: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ADVERTISERS_TARGETTED_NOTIFICATION_CAMPAIGNS}` +
        "?advertiserHashId=" +
        advertiserHashId,
      SM_CONSTANTS.RESULT_API_GET_ADVERTISERS_TARGETTED_NOTIFICATION_CAMPAIGNS,
    );
    this.apiHandler(apiParam);
  }
  getAdvertiserPayments(advertiserHashId: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ADVERTISERS_PAYMENTS}` +
        "?advertiserHashId=" +
        advertiserHashId,
      SM_CONSTANTS.RESULT_API_GET_ADVERTISERS_PAYMENTS,
    );
    this.apiHandler(apiParam);
  }

  setAdvertiserPayment(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_SET_ADVERTISERS_PAYMENTS}`,
      SM_CONSTANTS.RESULT_API_SET_ADVERTISERS_PAYMENTS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getAllFCMTopic() {
    let hashId = localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID);
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_FCM_TOPICS}` +
        "?admin_auth_id=" +
        hashId,
      SM_CONSTANTS.RESULT_API_GET_FCM_TOPICS,
    );
    this.apiHandler(apiParam);
  }

  addEditFCMTopic(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_FCM_TOPIC}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_FCM_TOPIC,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  assignSubscriberToFCMTopic(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ASSIGN_SUBSCRIBER_TO_FCM_TOPIC}`,
      SM_CONSTANTS.RESULT_API_ASSIGN_SUBSCRIBER_TO_FCM_TOPIC,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getSubscriberFromFCMTopic(topicHashId: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_SUBSCRIBER_FROM_FCM_TOPICS}` +
        "?topicHashId=" +
        topicHashId,
      SM_CONSTANTS.RESULT_API_GET_SUBSCRIBER_FROM_FCM_TOPICS,
    );
    this.apiHandler(apiParam);
  }

  removeSubscriberFromFCMTopic(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_REMOVE_SUBSCRIBER_FROM_FCM_TOPICS}`,
      SM_CONSTANTS.RESULT_API_REMOVE_SUBSCRIBER_FROM_FCM_TOPICS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getInventoryItems(entityHashId: any, pageNumber: any, searchkey: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_INVENTORY_ITEMS}` +
        "?entityHashId=" +
        entityHashId +
        "&searchKey=" +
        searchkey +
        "&pageNo=" +
        pageNumber +
        "&count=25",
      SM_CONSTANTS.RESULT_API_GET_INVENTORY_ITEMS,
    );
    this.apiHandler(apiParam);
  }

  addEditInventoryItem(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INVENTORY_ITEM}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INVENTORY_ITEM,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getInventoryItemTemplateList(pageNo: number) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_INVENTORY_ITEMS_TEMPLATE_LIST}` +
        "?pageNo=" +
        pageNo +
        "&count=25",
      SM_CONSTANTS.RESULT_API_GET_INVENTORY_ITEMS_TEMPLATE_LIST,
    );
    this.apiHandler(apiParam);
  }

  addEditInventoryItemTemplateDetails(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INVENTORY_ITEM_TEMPLATE_LIST}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INVENTORY_ITEM_TEMPLATE_LIST,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  //app functionality apis

  getAppFunctionalityList() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_APP_FUNCTIONALITY_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_APP_FUNCTIONALITY_LIST,
    );
    this.apiHandler(apiParam);
  }

  addEditAppFunctionality(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_APP_FUNCTIONALITY_LIST}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_APP_FUNCTIONALITY_LIST,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getFunctionalityByEntityId(entityHashId: string) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_APP_FUNCTIONALITY_BY_ENTITY_ID}` +
        "?entityHashId=" +
        entityHashId,
      SM_CONSTANTS.RESULT_API_GET_APP_FUNCTIONALITY_BY_ENTITY_ID,
    );
    this.apiHandler(apiParam);
  }

  addEditFunctionalityToEntity(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_APP_FUNCTIONALITY_TO_ENTITY}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_APP_FUNCTIONALITY_TO_ENTITY,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getSearchAllFCMTopic(searchKey: string) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_FCM_TOPICS}` +
        "?searchKey=" +
        searchKey,
      SM_CONSTANTS.RESULT_API_GET_FCM_TOPICS,
    );
    this.apiHandler(apiParam);
  }

  getEntitySlotsInfo(
    entityHashId: any,
    bookingType: any,
    tomorrowDataOnly: any,
  ) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());

    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        entityHashId: entityHashId,
        bookingType: bookingType,
        tomorrowDataOnly: tomorrowDataOnly,
        currentDate: currentDate,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_SLOTS_INFO}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_SLOTS_INFO,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getEntitySlotsInfo2(
    entityHashId: any,
    bookingType: any,
    tomorrowDataOnly: any,
  ) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData: IHttpHeader[] = [
      {
        accountHashId: SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        entityHashId: entityHashId,
        bookingType: bookingType,
        tomorrowDataOnly: tomorrowDataOnly,
        currentDate: currentDate,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_SLOTS_INFO}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_SLOTS_INFO2,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  updateBookingStatus(bodyData: any) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];

    if (bodyData) {
      bodyData.bookingStatusInfo.time_zone = timezone;
      bodyData.bookingStatusInfo.creation_time = this.formatDateString();
    }

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_BOOKING_STATUS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS,
      bodyData,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  updateBookingStatusForNewBooking(bodyData: any) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    if (bodyData) {
      bodyData.bookingStatusInfo.time_zone = timezone;
      bodyData.bookingStatusInfo.creation_time = this.formatDateString();
    }
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_BOOKING_STATUS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_FOR_NEW_BOOKING,
      bodyData,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  updateBookingStatusWithInvoice(bodyData: any) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    if (bodyData) {
      bodyData.bookingStatusInfo.time_zone = timezone;
      bodyData.bookingStatusInfo.creation_time = this.formatDateString();
    }
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_BOOKING_STATUS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_STATUS_WITH_INVOICE,
      bodyData,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  resetBookingDetails(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_RESET_BOOKING_DETAILS}`,
      SM_CONSTANTS.RESULT_API_RESET_BOOKING_DETAILS,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getEntityInvoiceDetails(bookingHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        bookingHashId: bookingHashId,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_INVOICE_DETAILS}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_INVOICE_DETAILS,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  addEditEntityInvoice(bodyData: any) {
    const headerData = [
      {
        creatorAccountHash: localStorage.getItem(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        )!,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ENTITY_INVOICE_DETAILS}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_INVOICE_DETAILS,
      bodyData,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getBookingOperationDetails(appointmentHashId: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_BOOKING_OPERATION_DETAILS}` +
        "?appointmentHashId=" +
        appointmentHashId,
      SM_CONSTANTS.RESULT_API_GET_BOOKING_OPERATION_DETAILS,
    );
    this.apiHandler(apiParam);
  }

  customizeBookingDetails(data: any) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (data) {
      data.time_zone = timezone;
    }
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_CUSTOMISE_BOOKING_DETAILS}`,
      SM_CONSTANTS.RESULT_API_CUSTOMISE_BOOKING_DETAILS,
      data,
    );
    this.apiHandler(apiParam);
  }

  /**Tax and GST */

  getEntityTaxData(businessHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        businessHashId: businessHashId,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_TAX_DATA}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_DATA,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  addEditEntityTaxData(body: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ENTITY_TAX_DATA}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_TAX_DATA,
      body,
    );
    this.apiHandler(apiParam);
  }

  getBillDiscount(businessHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        businessHashId: businessHashId,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_BILL_DISCOUNT}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_BILL_DISCOUNT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  addEditBillDiscount(body: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ENTITY_BILL_DISCOUNT}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_BILL_DISCOUNT,
      body,
    );
    this.apiHandler(apiParam);
  }

  getSubcriptionHistoryById(
    accountHashId: any,
    isUserPlan: any,
    countryCode: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: accountHashId,
        isUserPlan: isUserPlan,
        countryCode: countryCode,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_SUBSCRIPTION_HISTORY_BY_ID}`,
      SM_CONSTANTS.RESULT_API_GET_SUBSCRIPTION_HISTORY_BY_ID,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  updateEntitySubsciptionInfo(
    entityHashId: any,
    subscriptionHashId: any,
    bodyData: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        entityHashId: entityHashId,
        subscriptionHashId: subscriptionHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENTITY_SUBSCRIPTION_INFO}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SUBSCRIPTION_INFO,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  getPlansList() {
    let countryInfo =
      typeof sessionStorage.getItem(
        SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
      ) == "string"
        ? JSON.parse(
            sessionStorage.getItem(
              SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
            )!,
          )
        : sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT,
          );
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        countryCode: countryInfo ? countryInfo.countryCode : "+91",
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_PLANS_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_PLANS_LIST,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  createSubscriptionOrder(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_CREATE_SUBSCRIPTION_ORDER}`,
      SM_CONSTANTS.RESULT_API_CREATE_SUBSCRIPTION_ORDER,
    );
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }
  validatePaymentSignature(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_VALIDATE_PAYMENT_SIGNATURE}`,
      SM_CONSTANTS.RESULT_API_VALIDATE_PAYMENT_SIGNATURE,
    );
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }
  updatePaymentRecord(bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_PAYMENT_RECORD}`,
      SM_CONSTANTS.RESULT_API_UPDATE_PAYMENT_RECORD,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  getShopEntityTimeDetails(entityHash: string) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        entityHashId: localStorage.getItem(
          SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
        )!,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_SHOP_SERVICE_TIMINGS}`,
      SM_CONSTANTS.RESULT_API_GET_SHOP_SERVICE_TIMINGS,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getHomeServiceTimeDetails(entityHash: string) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        entityHashId: localStorage.getItem(
          SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
        )!,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_HOME_SERVICE_TIMINGS}`,
      SM_CONSTANTS.RESULT_API_GET_HOME_SERVICE_TIMINGS,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  updateEntityShopTimeInfo(entityHashId: string, bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        entityHashId: entityHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENTITY_SHOP_SERVICE_TIMINGS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SHOP_SERVICE_TIMINGS,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }
  updateHomeServiceTimeInfo(entityHashId: string, bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        entityHashId: entityHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENTITY_HOME_SERVICE_TIMINGS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_HOME_SERVICE_TIMINGS,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  updateFcmTokenInfo(accountId: any, body: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: accountId,
        tokenType: "3",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_FCM_TOKEN_INFO}`,
      SM_CONSTANTS.RESULT_API_UPDATE_FCM_TOKEN_INFO,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = body;
    this.apiHandler(apiParam);
  }

  getNotifications() {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_NOTIFICATIONS}`,
      SM_CONSTANTS.RESULT_API_GET_NOTIFICATIONS,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getFeedBacks(entityHash: string, pageNo: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: localStorage.getItem(
          SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
        )!,
        count: "25",
        pageNo: pageNo,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_FEEDBACKS}`,
      SM_CONSTANTS.RESULT_API_GET_FEEDBACKS,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getLatestBookingQRCode(entityHash: string) {
    const headerData: IHttpHeader[] = [
      {
        businessHashId: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_BOOKING_QR}`,
      SM_CONSTANTS.RESULT_API_GET_BOOKING_QR,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  createBookingQRCode(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_CREATE_BOOKING_QR}`,
      SM_CONSTANTS.RESULT_API_CREATE_BOOKING_QR,
    );
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  updateUserProfile(bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_USER_PROFILE}`,
      SM_CONSTANTS.RESULT_API_UPDATE_USER_PROFILE,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  getEntityActiveSubscription(entityHash: string) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_ACTIVE_SUBSCRIPTION}` +
        "?entityHashId=" +
        entityHash,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_ACTIVE_SUBSCRIPTION,
    );
    this.apiHandler(apiParam);
  }

  getEmployeeRequestList(entityHash: string) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHash,
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYEE_REQUEST_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_REQUEST_LIST,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getEmployeeList(entityHashId: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHashId,
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        sendAll: "0",
        currentDate: currentDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYEE_LIST}`,
      SM_CONSTANTS.GET_EMPLOYEE_LIST_RESULT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  sendEmployeeRequest(entityHashId: any, body: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        entityHashId: entityHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SEND_EMPLOYEE_REQUEST}`,
      SM_CONSTANTS.RESULT_API_SEND_EMPLOYEE_REQUEST,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = body;
    this.apiHandler(apiParam);
  }

  getSalaryInfo(employeeHashId: any, IsSetting: any) {
    const headerData: IHttpHeader[] = [
      {
        employeeHashId: employeeHashId,
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        isSetting: IsSetting,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_SALARY_INFO}`,
      SM_CONSTANTS.RESULT_API_GET_SALARY_INFO,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getOnlySalaryInfo(employeeHashId: any, IsSetting: any) {
    const headerData: IHttpHeader[] = [
      {
        employeeHashId: employeeHashId,
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        isSetting: IsSetting,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_SALARY_INFO}`,
      SM_CONSTANTS.RESULT_API_GET_SALARY_INFO_ONLY,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  updateSalaryInfo(employeeHashId: any, body: any, isSetting: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        employeeHashId: employeeHashId,
        isSetting: isSetting,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_SALARY_INFO}`,
      SM_CONSTANTS.RESULT_API_UPDATE_SALARY_INFO,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = body;
    this.apiHandler(apiParam);
  }

  getUserExpensesList(entityHashId: any, employeeHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHashId,
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        employeeHashId: employeeHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_USER_EXPENSES_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_USER_EXPENSES_LIST,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  updateUserExpenseInfo(creditorHashId: any, body: any, entityHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        creditorHashId: creditorHashId,
        entityHashId: entityHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_USER_EXPENSES_INFO}`,
      SM_CONSTANTS.RESULT_API_UPDATE_USER_EXPENSES_INFO,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = body;
    this.apiHandler(apiParam);
  }
  updateUserSubsciptionInfo(subscriptionHashId: any, body: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        subscriptionHashId: subscriptionHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_USER_SUBSCRIPTION_INFO}`,
      SM_CONSTANTS.RESULT_API_UPDATE_USER_SUBSCRIPTION_INFO,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = body;
    this.apiHandler(apiParam);
  }
  addAsEmployee(requestHashId: any, body: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        requestHashId: requestHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_AS_EMPLOYEE}`,
      SM_CONSTANTS.RESULT_API_ADD_AS_EMPLOYEE,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = body;
    this.apiHandler(apiParam);
  }
  updateEmployeeInfo(employeeHashId: any, body: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
        employeeHashId: employeeHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_EMPLOYEE_INFO}`,
      SM_CONSTANTS.RESULT_API_UPDATE_EMPLOYEE_INFO,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    apiParam.body = body;
    this.apiHandler(apiParam);
  }

  getTransactionsList() {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_TRANSACTIONS_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_TRANSACTIONS_LIST,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getEmployeeSubscriptionInfo(employeeHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: this._storageService.getLocalStorageValue(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        ),
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYEE_SUBSCRIPTION_INFO}` +
        "?employeeHashId=" +
        employeeHashId,
      SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_SUBSCRIPTION_INFO,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getEmployeeDutyLog(
    entityHash: string,
    employeeHashId: string,
    count: any,
    pageNo: any,
  ) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYEE_DUTY_LOG}` +
        "?entityHashId=" +
        entityHash +
        "&employeeHashId=" +
        employeeHashId +
        "&count=" +
        count +
        "&pageNo=" +
        pageNo,
      SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_DUTY_LOG,
    );
    this.apiHandler(apiParam);
  }

  resetInvoiceData(appointmentHashId: any, isInternational: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_RESET_INVOICE_DATA}` +
        "?appointmentHashId=" +
        appointmentHashId +
        "&isInternational=" +
        isInternational,
      SM_CONSTANTS.RESULT_API_RESET_INVOICE_DATA,
    );
    this.apiHandler(apiParam);
  }

  getHistoricAttendanceListForFitnessEntity(
    entityHash: any,
    from_date: any,
    to_date: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        from_date: from_date,
        to_date: to_date,
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_HISTORIC_ATTENDANCE_LIST_FOR_FITNESS_ENTITY}`,
      SM_CONSTANTS.RESULT_API_GET_HISTORIC_ATTENDANCE_LIST_FOR_FITNESS_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  addEditPaymentRecord(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_PAYMENT_RECORD}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_PAYMENT_RECORD,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  contactUs(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_CONTACT_US}`,
      SM_CONSTANTS.RESULT_API_CONTACT_US,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getCustomersByEntityId(entityHash: string, pageNo: any, count?: any) {
    console.log(count);
    let c = count && count != undefined ? count : "500";
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_CUSTOMERS_BY_ENTITY_ID}` +
        "?entityHashId=" +
        entityHash +
        "&count=" +
        c +
        "&pageNo=" +
        pageNo,
      SM_CONSTANTS.RESULT_API_GET_CUSTOMERS_BY_ENTITY_ID,
    );
    this.apiHandler(apiParam);
  }
  getCustomersWithDuesByEntityId(entityHash: string, pageNo: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_CUSTOMERS_WITH_DUES_BY_ENTITY_ID}` +
        "?entityHashId=" +
        entityHash +
        "&count=500" +
        "&pageNo=" +
        pageNo,
      SM_CONSTANTS.RESULT_API_GET_CUSTOMERS_WITH_DUES_BY_ENTITY_ID,
    );
    this.apiHandler(apiParam);
  }
  getLongAbsentCustomersByEntityId(entityHash: string, pageNo: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_LONG_ABSENT_CUSTOMERS_BY_ENTITY_ID}` +
        "?entityHashId=" +
        entityHash +
        "&count=500" +
        "&pageNo=" +
        pageNo,
      SM_CONSTANTS.RESULT_API_GET_LONG_ABSENT_CUSTOMERS_BY_ENTITY_ID,
    );
    this.apiHandler(apiParam);
  }
  getCustomerDataByKeyword(
    entityHash: string,
    pageNo: any,
    searchKey: any,
    type: any,
  ) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_CUSTOMER_BY_SEARCH}` +
        "?entityHashId=" +
        entityHash +
        "&count=500" +
        "&pageNo=" +
        pageNo +
        "&searchKey=" +
        searchKey +
        "&type=" +
        type,
      SM_CONSTANTS.RESULT_API_GET_CUSTOMER_BY_SEARCH,
    );
    this.apiHandler(apiParam);
  }
  getEntityCustomerBookingHistory(
    entityHash: string,
    phone: any,
    pageNo: any,
    name: any,
    countryCode: any,
  ) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_CUSTOMER_BOOKING_HISTORY}` +
        "?entityHashId=" +
        entityHash +
        "&name=" +
        name +
        "&phone=" +
        encodeURIComponent(phone) +
        "&count=500" +
        "&pageNo=" +
        pageNo +
        "&countryCode=" +
        (countryCode && countryCode != "null"
          ? encodeURIComponent(countryCode)
          : ""),
      SM_CONSTANTS.RESULT_API_GET_ENTITY_CUSTOMER_BOOKING_HISTORY,
    );
    this.apiHandler(apiParam);
  }
  getEntityCustomerDueBookingList(
    entityHash: string,
    phone: any,
    pageNo: any,
    name: any,
    countryCode: any,
  ) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_CUSTOMER_DUE_BOOKING_HISTORY}` +
        "?entityHashId=" +
        entityHash +
        "&name=" +
        name +
        "&phone=" +
        encodeURIComponent(phone) +
        "&count=500" +
        "&pageNo=" +
        pageNo +
        "&countryCode=" +
        (countryCode && countryCode != "null"
          ? encodeURIComponent(countryCode)
          : ""),
      SM_CONSTANTS.RESULT_API_GET_ENTITY_CUSTOMER_DUE_BOOKING_HISTORY,
    );
    this.apiHandler(apiParam);
  }

  getBookingDetailById(bookingHash: any) {
    const headerData: IHttpHeader[] = [
      {
        bookingHashId: bookingHash,
        employeeHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        )!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_BOOKING_DETAIL_BY_ID}`,
      SM_CONSTANTS.RESULT_API_GET_BOOKING_DETAIL_BY_ID,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  setNotificationPrivacy(dnd: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        dnd: dnd,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_SET_NOTIFICATION_PRIVACY}`,
      SM_CONSTANTS.RESULT_API_SET_NOTIFICATION_PRIVACY,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  setRequest(bodyData: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        markedToHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_SET_REQUEST}`,
      SM_CONSTANTS.RESULT_API_SET_REQUEST,
      bodyData,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getMessagesByID() {
    if (localStorage.getItem(SM_CONSTANTS.PROFILE_HASH)) {
      const headerData: IHttpHeader[] = [
        {
          profileHashId: localStorage.getItem(SM_CONSTANTS.PROFILE_HASH)!,
        },
      ];
      const apiParam = new HttpMethodArgs(
        SM_CONSTANTS.REQUEST_GET,
        `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_MESSAGES_BY_ID}`,
        SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID,
      );
      apiParam.httpHeader = this.composeHttpHeader(headerData);
      this.apiHandler(apiParam);
    }
  }
  getMessagesByIDForEmployee() {
    const headerData: IHttpHeader[] = [
      {
        profileHashId: localStorage.getItem(SM_CONSTANTS.PROFILE_HASH)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_MESSAGES_BY_ID}`,
      SM_CONSTANTS.RESULT_API_GET_MESSAGES_BY_ID_FOR_EMPLOYEE,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getSubMessagesByID(messageHash: any) {
    const headerData: IHttpHeader[] = [
      {
        messageHashId: messageHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_SUB_MESSAGES_BY_ID}`,
      SM_CONSTANTS.RESULT_API_GET_SUB_MESSAGES_BY_ID,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  updateMessageThread(
    senderHashId: any,
    receiverHashId: any,
    entitypubHash: any,
    bodyData: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        senderHashId: senderHashId,
        receiverHashId: receiverHashId,
        entityPublicHash: entitypubHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_MESSAGE_THREAD}`,
      SM_CONSTANTS.RESULT_API_UPDATE_MESSAGE_THREAD,
      bodyData,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getEntityInventoryInOutData(entityHash: string, pageNo: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_INVENTORY_IN_OUT_DATA}` +
        "?entityHashId=" +
        entityHash +
        "&count=25" +
        "&pageNo=" +
        pageNo,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_INVENTORY_IN_OUT_DATA,
    );
    this.apiHandler(apiParam);
  }

  setInventoryItemActivity(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_INVENTORY_ITEM_ACTIVITY}`,
      SM_CONSTANTS.RESULT_API_SET_INVENTORY_ITEM_ACTIVITY,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  editInventoryActivity(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_EDIT_INVENTORY_ACTIVITY}`,
      SM_CONSTANTS.RESULT_API_EDIT_INVENTORY_ACTIVITY,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getEntityPurchaseItems(entityHashId: any, pageNo: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ENTITY_PURCHASE_ITEMS}` +
        "?count=25" +
        "&pageNo=" +
        pageNo +
        "&entityHashId=" +
        entityHashId,
      SM_CONSTANTS.RESULT_API_ENTITY_PURCHASE_ITEMS,
    );
    this.apiHandler(apiParam);
  }
  getEntityPurchaseOverview(entityHashId: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ENTITY_PURCHASE_OVERVIEW}` +
        "?entityHashId=" +
        entityHashId +
        "&date=" +
        currentDate,
      SM_CONSTANTS.RESULT_API_ENTITY_PURCHASE_OVERVIEW,
    );
    this.apiHandler(apiParam);
  }
  getEntityExpenseOverview(entityHashId: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    console.log(currentDate);
    console.log(entityHashId);

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ENTITY_EXPENSES_OVERVIEW}` +
        "?entityHashId=" +
        entityHashId +
        "&date=" +
        currentDate,
      SM_CONSTANTS.RESULT_API_ENTITY_EXPENSES_OVERVIEW,
    );
    this.apiHandler(apiParam);
  }

  addEditPurchaseItem(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_PURCHASE_ITEM}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_PURCHASE_ITEM,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  getExpensesList(pageNo: any) {
    const headerData: IHttpHeader[] = [
      {
        count: "500",
        pageNo: pageNo,
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        profileHashId: localStorage.getItem(SM_CONSTANTS.PROFILE_HASH)!,
        entityHashId: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_EXPENSES_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_EXPENSES_LIST,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  updateExpenseInfo(bodydata: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        profileHashId: localStorage.getItem(SM_CONSTANTS.PROFILE_HASH)!,
        entityHashId: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_EXPENSE_INFO}`,
      SM_CONSTANTS.RESULT_API_UPDATE_EXPENSE_INFO,
      bodydata,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  sendUnblockRequest(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_SEND_UNBLOCK_REQUEST}`,
      SM_CONSTANTS.RESULT_API_SEND_UNBLOCK_REQUEST,
      bodydata,
    );
    this.apiHandler(apiParam);
  }

  getMessageNotificationStatus() {
    const headerData: IHttpHeader[] = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_MESSAGE_NOTIFICATION_STATUS}`,
      SM_CONSTANTS.RESULT_API_GET_MESSAGE_NOTIFICATION_STATUS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  //-----------------------    REPORT APIS    -----------------------//

  getSalesReport(
    entityHashId: any,
    frequencyType: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHashId,
        frequencyType: frequencyType,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_SALES_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_SALES_REPORT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getEmployeeSalesReport(
    entityHashId: any,
    frequencyType: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHashId,
        frequencyType: frequencyType,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYEE_SALES_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_SALES_REPORT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getExpenditureReport(
    entityHashId: any,
    frequencyType: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHashId,
        frequencyType: frequencyType,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_EXPENDITURE_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_EXPENDITURE_REPORT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  EmployeeSalaryReport(
    entityHashId: any,
    frequencyType: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHashId,
        frequencyType: frequencyType,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYEE_SALARY_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_SALARY_REPORT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getBookingReport(
    entityHashId: any,
    frequencyType: any,
    fromDate: any,
    toDate: any,
    revenueMode: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        revenueMode: revenueMode,
        entityHashId: entityHashId,
        frequencyType: frequencyType,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_BOOKING_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_BOOKING_REPORT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getServiceReport(
    entityHashId: any,
    frequencyType: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHashId,
        frequencyType: frequencyType,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_SERVICE_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_SERVICE_REPORT,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getInvoiceReport(entityHashId: any, fromDate: any, toDate: any) {
    const header: IHttpHeader[] = [
      {
        businessHashId: entityHashId,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_INVOICE_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_INVOICE_REPORT,
    );
    apiParam.httpHeader = this.composeHttpHeader(header);
    this.apiHandler(apiParam);
  }
  // getEntityServicePaymentsForTransfer(entityHashId:any,fromDate: any,toDate: any) {

  //   const headerData: IHttpHeader[] = [
  //     {
  //       entityHashId: entityHashId,
  //       fromDate: fromDate,
  //       toDate: toDate
  //     }
  //   ];
  //   const apiParam = new HttpMethodArgs(
  //     SM_CONSTANTS.REQUEST_GET,
  //     `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_INVOICE_REPORT}`,
  //     SM_CONSTANTS.RESULT_API_GET_INVOICE_REPORT
  //   );
  //   apiParam.httpHeader = this.composeHttpHeader(headerData);
  //   this.apiHandler(apiParam);
  // }
  getInventoryActivityReport(entityHashId: any, fromDate: any, toDate: any) {
    const headerData = [
      {
        entityHashId: entityHashId,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_INVENTORY_ACTIVITY_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_INVENTORY_ACTIVITY_REPORT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getPurchaseReport(entityHashId: any, fromDate: any, toDate: any) {
    const headerData = [
      {
        entityHashId: entityHashId,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_PURCHASE_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_PURCHASE_REPORT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getRevenueInsightReport(entityHashId: any, fromDate: any, toDate: any) {
    const headerData = [
      {
        entityHashId: entityHashId,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_REVENUE_INSIGHT_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_REVENUE_INSIGHT_REPORT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getTaxCollectionReport(entityHashId: any, fromDate: any, toDate: any) {
    const headerData = [
      {
        entityHashId: entityHashId,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_TAX_COLLECTION_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_TAX_COLLECTION_REPORT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getEntityFollowingList(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHashId: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_FOLLOWING_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_FOLLOWING_LIST,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getPostsAsPerID(accountHash: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData: IHttpHeader[] = [
      {
        accountHashId: accountHash,
        currentDate: currentDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_GET_POSTS_AS_PER_ID}`,
      SM_CONSTANTS.RESULT_API_GET_POSTS_AS_PER_ID,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getAllAssetsAsPerID(accountHash: any) {
    const headerData: IHttpHeader[] = [
      {
        relativeHashId: accountHash,
        assetType: "4",
        entityAssetType: "0",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ALL_ASSETS_AS_PER_ID}`,
      SM_CONSTANTS.RESULT_API_GET_ALL_ASSETS_AS_PER_ID,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  setRequestReport(bodyData: any, markedTo: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        markedToHashId: markedTo,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_SET_REQUEST}`,
      SM_CONSTANTS.RESULT_API_SET_REQUEST,
      bodyData,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  updateMessage(bodyData: any, messageHashId: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        messageHashId: messageHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_MESSAGE}`,
      SM_CONSTANTS.RESULT_API_UPDATE_MESSAGE,
      bodyData,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  getFeedAsPerBusinessID(accountHash: any, entityHashId: any, pageNo: any) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: accountHash,
        entityHashId: entityHashId,
        postType: "0",
        pageNo: pageNo,
        noOfItems: "8",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_GET_FEED_AS_PER_BUSINESS_ID}`,
      SM_CONSTANTS.RESULT_API_GET_FEED_AS_PER_BUSINESS_ID,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  enableOnlinePayments(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ENABLE_ONLINE_PAYMENTS}`,
      SM_CONSTANTS.RESULT_API_ENABLE_ONLINE_PAYMENTS,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  generateInvoicePDF(invoiceHash: any, bodydata: any) {
    const headerData = [
      {
        invoiceHash: invoiceHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._uploadServiceBaseUrl}/${SM_CONSTANTS.API_GENERATE_INVOICE_PDF}`,
      SM_CONSTANTS.RESULT_API_GENERATE_INVOICE_PDF,
      bodydata,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  generateInternationalInvoicePDF(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._uploadServiceBaseUrl}/${SM_CONSTANTS.API_GENERATE_INTERNATIONAL_INVOICE_PDF}`,
      SM_CONSTANTS.RESULT_API_GENERATE_INTERNATIONAL_INVOICE_PDF,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getEntitySpecificSupportTickets(entityHash: any, pageNo: any) {
    const headerData = [
      {
        entityHash: entityHash,
        pageNo: pageNo,
        count: "25",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_SPECIFIC_SUPPORT_TICKETS}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_SPECIFIC_SUPPORT_TICKETS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getSupportThread(supporTicketHash: any, pageno: any) {
    const headerData = [
      {
        supporTicketHash: supporTicketHash,
        pageNo: pageno,
        count: "25",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_SUPPORT_THREAD}`,
      SM_CONSTANTS.RESULT_API_GET_SUPPORT_THREAD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  createSupportTicket(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_CREATE_SUPPORT_TICKET}`,
      SM_CONSTANTS.RESULT_API_CREATE_SUPPORT_TICKET,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  createSupportTicketResponse(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_CREATE_SUPPORT_TICKET_RESPONSE}`,
      SM_CONSTANTS.RESULT_API_CREATE_SUPPORT_TICKET_RESPONSE,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  setSupportTicketStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_SET_SUPPORT_TICKET_STATUS}`,
      SM_CONSTANTS.RESULT_API_SET_SUPPORT_TICKET_STATUS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getEntityServiceTemplates() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/v2/${SM_CONSTANTS.API_GET_ENTITY_SERVICE_TEMPLATES}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_SERVICE_TEMPLATES,
    );
    this.apiHandler(apiParam);
  }

  getTodaysBookingsForDashboard(count: any, pageno: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: count,
        pageNo: pageno,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_TODAY_BOOKINGS_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_TODAY_BOOKINGS_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getUpcomingBookingsForDashboard(count: any, pageno: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: count,
        pageNo: pageno,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_UPCOMING_BOOKINGS_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_UPCOMING_BOOKINGS_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getLatestPurchasesForDashboard(count: any, pageno: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: count,
        pageNo: pageno,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_LATEST_PURCHASES_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_LATEST_PURCHASES_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getLatestInventoryStatusForDashboard(count: any, pageno: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: count,
        pageNo: pageno,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_LATEST_INVENTORY_STATUS_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_LATEST_INVENTORY_STATUS_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getLatestExpensesForDashboard(count: any, pageno: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: count,
        pageNo: pageno,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_LATEST_EXPENSES_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_LATEST_EXPENSES_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getTodaysEmployeeLogForDashboard(count: any, pageno: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: count,
        pageNo: pageno,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_TODAYS_EMPLOYEE_LOG_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_TODAYS_EMPLOYEE_LOG_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getCompositeSalesDataForDashboard() {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: "4",
        pageNo: "1",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_COMPOSITE_SALES_DATA_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_COMPOSITE_SALES_DATA_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getCompositeBookingDataForDashboard() {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: "4",
        pageNo: "1",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_COMPOSITE_BOOKING_DATA_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_COMPOSITE_BOOKING_DATA_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getCompositeExpenditureDataForDashboard() {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: "4",
        pageNo: "1",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_COMPOSITE_EXPENDITURE_DATA_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_COMPOSITE_EXPENDITURE_DATA_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEntityFeatureWiseCounts(entityHash: string) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        entityHash: entityHash,
        currentDate: currentDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_FEATURE_WISE_COUNTS}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_FEATURE_WISE_COUNTS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  updateEntityServices(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENTITY_SERVICES}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_SERVICES,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  updateEntityDetails(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENTITY_DETAILS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_DETAILS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  uploadEntityMedia(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._uploadServiceBaseUrl}/${SM_CONSTANTS.API_UPLOAD_ENTITY_MEDIA}`,
      SM_CONSTANTS.RESULT_API_UPLOAD_ENTITY_MEDIA,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  updateEntityLocation(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENTITY_LOCATION}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_LOCATION,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  deactivateEntity(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_DEACTIVATE_ENTITY}`,
      SM_CONSTANTS.RESULT_API_DEACTIVATE_ENTITY,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  setMediaAsDefault(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_MEDIA_AS_DEFAULT}`,
      SM_CONSTANTS.RESULT_API_SET_MEDIA_AS_DEFAULT,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  deleteUploadedMedia(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._uploadServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_UPLOADED_MEDIA}`,
      SM_CONSTANTS.RESULT_API_DELETE_UPLOADED_MEDIA,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  getBasicEntityList() {
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_BASIC_ENTITY_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_BASIC_ENTITY_LIST,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEmployeeDetails(employeeHash: any) {
    const headerData = [
      {
        employeeHash: employeeHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYEE_DETAILS}`,
      SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_DETAILS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEmployeeFeatureWiseCounts(employeeHash: any) {
    const headerData = [
      {
        employeeHash: employeeHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYEE_FEATURE_WISE_COUNT}`,
      SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_FEATURE_WISE_COUNT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  setNotificationReadStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_SET_NOTIFICATION_READ_STATUS}`,
      SM_CONSTANTS.RESULT_API_SET_NOTIFICATION_READ_STATUS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getBillDiscountData(entityHash: any) {
    const headerData = [
      {
        entityHash: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_DISCOUNT}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_DISCOUNT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  sendEmail(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_SEND_EMAIL}`,
      SM_CONSTANTS.RESULT_API_SEND_EMAIL,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  sendWhatsAppMessage(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_SEND_WHATSAPP}`,
      SM_CONSTANTS.RESULT_API_SEND_WHATSAPP,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getVirtualServiceTimings(entityHash: any) {
    const headerData = [
      {
        entityHash: localStorage.getItem(
          SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
        )!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_VIRTUAL_SERVICE_TIMINGS}`,
      SM_CONSTANTS.RESULT_API_GET_VIRTUAL_SERVICE_TIMINGS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  updateVirtualServiceTimingInfo(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_VIRTUAL_SERVICE_TIMINGS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_VIRTUAL_SERVICE_TIMINGS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  deleteEntityByOwner(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_ENTITY_BY_OWNER}`,
      SM_CONSTANTS.RESULT_API_DELETE_ENTITY_BY_OWNER,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  setEmployeeActivationStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_EMPLOYEE_ACTIVATION_STATUS}`,
      SM_CONSTANTS.RESULT_API_SET_EMPLOYEE_ACTIVATION_STATUS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getEntityInventoryStatus(entityHash: any) {
    const headerData = [
      {
        entityHash: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_INVENTORY_STATUS}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_INVENTORY_STATUS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getAllEnrollInterestByEntityId(
    entityHash: any,
    status: any,
    fromdate: any,
    todate: any,
    pageno: any,
    interesttype: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        status: status,
        fromDate: fromdate,
        toDate: todate,
        count: "25",
        pageNo: pageno,
        interestType: interesttype,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENROLL_INTEREST_BY_ENTITY_ID}`,
      SM_CONSTANTS.RESULT_API_GET_ENROLL_INTEREST_BY_ENTITY_ID,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  addEditEnrollInterestByEntity(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ENROLL_INTEREST_BY_ENTITY}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ENROLL_INTEREST_BY_ENTITY,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getEnrollInterestDetailsById(hash: any) {
    const headerData = [
      {
        hashId: hash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENROLL_INTEREST_DETAILS_BY_ID}`,
      SM_CONSTANTS.RESULT_API_GET_ENROLL_INTEREST_DETAILS_BY_ID,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getFitnessEnrolledMemberForAutoCorrect(entityHash: any, keyword: any) {
    const headerData = [
      {
        entityHash: entityHash,
        keyword: keyword,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_FITNESS_AUTOCORRECT}`,
      SM_CONSTANTS.RESULT_API_GET_FITNESS_AUTOCORRECT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getSearchByEnrollInterest(entityHash: any, keyword: any) {
    const headerData = [
      {
        entityHash: entityHash,
        keyword: keyword,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_SEARCH_BY_ENROLL_INTEREST}`,
      SM_CONSTANTS.RESULT_API_GET_SEARCH_BY_ENROLL_INTEREST,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEnrolledMembersListByType(
    entityHash: any,
    type: any,
    pageno: any,
    count?: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        type: type,
        count: count && count != undefined ? count : "500",
        pageNo: pageno,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENROLL_MEMBERS_SEARCH_BY_TYPE}`,
      SM_CONSTANTS.RESULT_API_GET_ENROLL_MEMBERS_SEARCH_BY_TYPE,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  updateEnrollInterestProgressStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENROLL_PROGRESS_STATUS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENROLL_PROGRESS_STATUS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  updateEnrollInterestStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENROLL_STATUS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENROLL_STATUS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  addEdiEnrolledMember(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ENROLL_MEMBERS}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ENROLL_MEMBERS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  addEditFitnessEntityInvoice(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_FITNESS_ENTITY_INVOICE}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_ENTITY_INVOICE,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  updateEnrolledMemberMembershipStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENROLLED_MEMBER_MEMBERSHIP_STATUS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENROLLED_MEMBER_MEMBERSHIP_STATUS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  addEditCustomerByEntity(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_CUSTOMER_BY_ENTITY}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_CUSTOMER_BY_ENTITY,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getMemberInvoiceDetails(invoiceHashId: any) {
    const headerData = [
      {
        invoiceHashId: invoiceHashId,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_MEMBER_INVOICE_DETAILS}`,
      SM_CONSTANTS.RESULT_API_GET_MEMBER_INVOICE_DETAILS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEnrolledMemberDetails(memberHashId: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        memberHashId: memberHashId,
        currentDate: currentDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENROLLED_MEMBER_DETAILS}`,
      SM_CONSTANTS.RESULT_API_GET_ENROLLED_MEMBER_DETAILS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEntityMembersAllInvoiceList(
    entityHash: any,
    countryCode: any,
    memberPhone: any,
    mhash: any,
  ) {
    // const headerData = [
    //   {
    //     entityHash: entityHash,
    //     countryCode:encodeURIComponent(countryCode),
    //     memberPhone:memberPhone,

    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_MEMBER_ALL_INVOICE_LIST}` +
        "?entityHash=" +
        entityHash +
        "&memberHash=" +
        mhash,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_MEMBER_ALL_INVOICE_LIST,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEntityMemberDueInvoiceList(
    entityHash: any,
    countryCode: any,
    customerPhone: any,
    mhash: any,
  ) {
    // const headerData = [
    //   {
    //     entityHash: entityHash,
    //     countryCode:encodeURIComponent(countryCode),
    //     customerPhone:customerPhone,
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_MEMBER_DUE_INVOICE_LIST}` +
        "?entityHash=" +
        entityHash +
        "&memberHash=" +
        mhash,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_MEMBER_DUE_INVOICE_LIST,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  deleteEntityAppointmentData(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_ENTITY_APPOINTMENT_DATA}`,
      SM_CONSTANTS.RESULT_API_DELETE_ENTITY_APPOINTMENT_DATA,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  deleteEntityCustomer(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_ENTITY_CUSTOMER_DATA}`,
      SM_CONSTANTS.RESULT_API_DELETE_ENTITY_CUSTOMER_DATA,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  deleteEntityMember(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_ENTITY_MEMBER_DATA}`,
      SM_CONSTANTS.RESULT_API_DELETE_ENTITY_MEMBER_DATA,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  deleteEntityRequestData(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_ENTITY_REQUEST_DATA}`,
      SM_CONSTANTS.RESULT_API_DELETE_ENTITY_REQUEST_DATA,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  addEditFitnessInvoicePaymentRecord(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_RECORD_FITNESS_INVOICE}`,
      SM_CONSTANTS.RESULT_API_RECORD_FITNESS_INVOICE,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  deleteEntityInvoice(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_ENTITY_INVOICE}`,
      SM_CONSTANTS.RESULT_API_DELETE_ENTITY_INVOICE,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  sendInvoiceViaEmail(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._uploadServiceBaseUrl}/${SM_CONSTANTS.API_SEND_INVOICE_EMAIL}`,
      SM_CONSTANTS.RESULT_API_SEND_INVOICE_EMAIL,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  sendInternationalInvoiceViaEmail(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._uploadServiceBaseUrl}/${SM_CONSTANTS.API_SEND_INTERNATIONAL_INVOICE_EMAIL}`,
      SM_CONSTANTS.RESULT_API_SEND_INTERNATIONAL_INVOICE_EMAIL,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getInternationalEntityTaxData(entityHash: any) {
    const headerData = [
      {
        entityHash: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_ENTITY_TAX_DATA}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_DATA,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  addEditInternationalEntityTaxData(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_DATA}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_DATA,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getInternationalEntityInvoiceDetails(appointmentHash: any) {
    const headerData = [
      {
        appointmentHash: appointmentHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_ENTITY_INVOICE_DETAILS}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_INVOICE_DETAILS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  addEditInternationalEntityInvoice(bodyData: any) {
    const headerData = [
      {
        creatorAccountHash: localStorage.getItem(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        )!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE,
      bodyData,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  addEditInternationalFitnessEntityInvoice(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INTERNATIONAL_FITNESS_ENTITY_INVOICE}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_FITNESS_ENTITY_INVOICE,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getInternationalFitnessEntityInvoiceDetails(
    invoiceHashId: any,
    entityHash: any,
  ) {
    const headerData = [
      {
        invoiceHashId: invoiceHashId,
        entityHash: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_FITNESS_ENTITY_INVOICE_DETAILS}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_FITNESS_ENTITY_INVOICE_DETAILS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getInternationalEntityInvoiceListForReports(
    entityHash: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_ENTITY_INVOICE_LIST_FOR_REPORTS}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_INVOICE_LIST_FOR_REPORTS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getInternationalTaxCollectionReport(
    entityHash: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_ENTITY_TAX_COLLECTION_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_COLLECTION_REPORT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getInternationalRevenueInsightReport(
    entityHash: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_REVENUE_INSIGHT_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_REVENUE_INSIGHT_REPORT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getInternationalSalesReport(
    entityHash: any,
    fromDate: any,
    toDate: any,
    frequency: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        fromDate: fromDate,
        toDate: toDate,
        frequency: frequency,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_SALES_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_SALES_REPORT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  addEditInternationInvoicePaymentRecord(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_INVOICE_PAYMENT_RECORD,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  addEditFitnessInternationalInvoicePaymentRecord(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_FITNESS_INTERNATIONAL_INVOICE_PAYMENT_RECORD,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  deleteInternationalInvoiceDetails(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_INTERNATIONAL_INVOICE_DETAILS}`,
      SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_INVOICE_DETAILS,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  addEditInternationalEntityTaxConfiguration(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_CONFIGURATION}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_CONFIGURATION,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  addEditEntityPrimaryTaxData(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_ENTITY_PRIMARY_TAX_DATA}`,
      SM_CONSTANTS.RESULT_API_ADD_ENTITY_PRIMARY_TAX_DATA,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  addEditInternationalEntityTaxSlabsData(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_SLABS_DATA}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_TAX_SLABS_DATA,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getEntityTaxSlabData(entityHash: any) {
    const headerData = [
      {
        entityHash: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_TAX_SLAB_DATA}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_TAX_SLAB_DATA,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getInternationalEntityTaxSlabsData(entityHash: any) {
    const headerData = [
      {
        entityHash: entityHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_TAX_SLAB_DATA,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  deleteEntityTaxSlabData(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_ENTITY_TAX_SLAB_DATA}`,
      SM_CONSTANTS.RESULT_API_DELETE_ENTITY_TAX_SLAB_DATA,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  deleteInternationalEntityTaxSlabData(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_INTERNATIONAL_ENTITY_TAX_SLAB_DATA}`,
      SM_CONSTANTS.RESULT_API_DELETE_INTERNATIONAL_ENTITY_TAX_SLAB_DATA,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  addEditEntityProduct(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ENTITY_PRODUCT}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_PRODUCT,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  deleteEntityProduct(bodyData: any) {
    // const headerData = [
    //   {
    //     creatorAccountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!
    //   }
    // ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_ENTITY_PRODUCT}`,
      SM_CONSTANTS.RESULT_API_DELETE_ENTITY_PRODUCT,
      bodyData,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEntityProductList(entityHash: any, pagenumber: any) {
    console.log(pagenumber);

    const headerData = [
      {
        entityHash: entityHash,
        pageNo: pagenumber,
        count: "25",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_PRODUCT_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_PRODUCT_LIST,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getProductDataByKeywod(entityHash: any, keyword: any, pagenumber: any) {
    console.log(pagenumber);

    const headerData = [
      {
        entityHash: entityHash,
        pageNo: pagenumber,
        keyword: keyword,
        count: "25",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_PRODUCT_DATA_BY_KEYWORD}`,
      SM_CONSTANTS.RESULT_API_GET_PRODUCT_DATA_BY_KEYWORD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getBookingsForFitnessEntity(
    entityHash: any,
    currentDate: any,
    bookingType: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        currentDate: currentDate,
        bookingType: bookingType,
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_BOOKINGS_FOR_FITNESS_ENTITY}`,
      SM_CONSTANTS.RESULT_API_GET_BOOKINGS_FOR_FITNESS_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getHistoricBookingListForFitnessEntity(
    entityHash: any,
    from_date: any,
    to_date: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        from_date: from_date,
        to_date: to_date,
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_HISTORIC_BOOKING_LIST_FOR_FITNESS_ENTITY}`,
      SM_CONSTANTS.RESULT_API_GET_HISTORIC_BOOKING_LIST_FOR_FITNESS_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  addEditEntityInvoiceWithoutBooking(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ENTITY_INVOICE_WITHOUT_BOOKING}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_INVOICE_WITHOUT_BOOKING,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  addEditInternationalEntityInvoiceWithoutBooking(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE_WITHOUT_BOOKING}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_INVOICE_WITHOUT_BOOKING,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  markMemberAttendanceStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_MARK_MEMBER_ATTENDANCE_STATUS}`,
      SM_CONSTANTS.RESULT_API_MARK_MEMBER_ATTENDANCE_STATUS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  getMembershipReport(entityHash: any, from_date: any, to_date: any) {
    const headerData = [
      {
        entityHash: entityHash,
        from_date: from_date,
        to_date: to_date,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._adminServiceBaseUrl}/${SM_CONSTANTS.API_GET_MEMBERSHIP_REPORT}`,
      SM_CONSTANTS.RESULT_API_GET_MEMBERSHIP_REPORT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getAccountDataByPhoneNumber(
    entityHash: string,
    countryCode: any,
    phone: any,
  ) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_GET_ACCOUNT_DATA_BY_PHONE_NUMBER}` +
        "?entityHash=" +
        entityHash +
        "&phone=" +
        encodeURIComponent(phone) +
        "&countryCode=" +
        encodeURIComponent(countryCode),
      SM_CONSTANTS.RESULT_API_GET_ACCOUNT_DATA_BY_PHONE_NUMBER,
    );
    this.apiHandler(apiParam);
  }
  getMemberAttendanceByEntity(entityHash: string, memberHash: any) {
    const headerData = [
      {
        entityHash: entityHash,
        memberHash: memberHash,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_MEMBER_ATTENDANCE_BY_ENTITY}`,
      SM_CONSTANTS.RESULT_API_GET_MEMBER_ATTENDANCE_BY_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  markMemberAbsentByEntity(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_MARK_MEMBER_ABSENT_BY_ENTITY}`,
      SM_CONSTANTS.RESULT_API_MARK_MEMBER_ABSENT_BY_ENTITY,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  setEnrolledMemberPhoneNumber(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_SET_ENROLLED_MEMBER_PHONE_NUMBER}`,
      SM_CONSTANTS.RESULT_API_SET_ENROLLED_MEMBER_PHONE_NUMBER,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  deleteMemberAttendanceDataByEntity(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_MEMBER_ATTENDANCE_DATA_BY_ENTITY}`,
      SM_CONSTANTS.RESULT_API_DELETE_MEMBER_ATTENDANCE_DATA_BY_ENTITY,
      bodyData,
    );

    this.apiHandler(apiParam);
  }
  setMessageReadStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_SET_MESSAGE_READ_STATUS}`,
      SM_CONSTANTS.RESULT_API_SET_MESSAGE_READ_STATUS,
      bodyData,
    );

    this.apiHandler(apiParam);
  }

  getEntityCustomerPaymentHistory(
    entityHash: string,
    countryCode: any,
    phone: any,
    name: any,
    pageNo: any,
  ) {
    const headerData = [
      {
        entityHash: entityHash,
        phone: phone,
        name: name,
        pageNo: pageNo,
        count: "500",
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_CUSTOMER_PAYMENT_HISTORY}` +
        "?countryCode=" +
        encodeURIComponent(countryCode),
      SM_CONSTANTS.RESULT_API_GET_ENTITY_CUSTOMER_PAYMENT_HISTORY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getMemberDataByKeyword(
    entityHash: string,
    pageNo: any,
    searchKey: any,
    type: any,
  ) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_MEMBER_DATA_BY_KEYWORD}` +
        "?entityHash=" +
        entityHash +
        "&count=500" +
        "&pageNo=" +
        pageNo +
        "&searchKey=" +
        searchKey +
        "&type=" +
        type,
      SM_CONSTANTS.RESULT_API_GET_MEMBER_DATA_BY_KEYWORD,
    );
    this.apiHandler(apiParam);
  }

  updatePostInfo(bodyData: any, entityHashId: string) {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
      { entityHashId: entityHashId },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_POST_INFO}`,
      SM_CONSTANTS.RESULT_API_UPDATE_POST_INFO,
    );
    apiParam.body = bodyData;
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }

  setEmployeeDutyData(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_EMPLOYEE_DUTY_DATA}`,
      SM_CONSTANTS.RESULT_API_SET_EMPLOYEE_DUTY_DATA,
    );
    apiParam.body = bodyData;
    this.apiHandler(apiParam);
  }

  getJobInvitations(
    accountHash: string,
    countryCode: any,
    phone: any,
    is_active: any,
  ) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_JOB_INVITATIONS}` +
        "?accountHash=" +
        accountHash +
        "&countryCode=" +
        encodeURIComponent(countryCode) +
        "&phone=" +
        phone +
        "&is_active=" +
        is_active,
      SM_CONSTANTS.RESULT_API_GET_JOB_INVITATIONS,
    );
    this.apiHandler(apiParam);
  }
  getEmployerList() {
    const headerData: IHttpHeader[] = [
      {
        accountHashId: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYER_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_EMPLOYER_LIST,
    );
    apiParam.httpHeader = this.composeHttpHeader(headerData);
    this.apiHandler(apiParam);
  }
  getCountryData() {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_COUNTRY_DATA}`,
      SM_CONSTANTS.RESULT_API_GET_COUNTRY_DATA,
    );
    this.apiHandler(apiParam);
  }

  getJobInvitationDetails(hashid: any) {
    const headerData: IHttpHeader[] = [{ hashId: hashid }];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_JOB_INVITATION_DETAILS}`,
      SM_CONSTANTS.RESULT_API_GET_JOB_INVITATION_DETAILS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  assignEmployeeToMember(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ASSIGN_EMPLOYEE_TO_MEMBER}`,
      SM_CONSTANTS.RESULT_API_ASSIGN_EMPLOYEE_TO_MEMBER,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  UpdateMemberSession(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_MEMBER_SESSION}`,
      SM_CONSTANTS.RESULT_API_UPDATE_MEMBER_SESSION,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  deleteLinkedBankAccount(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_LINKED_BANK_ACCOUNT}`,
      SM_CONSTANTS.RESULT_API_DELETE_LINKED_BANK_ACCOUNT,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  linkEntityBankAccount(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_LINK_ENTITY_BANK_ACCOUNT}`,
      SM_CONSTANTS.RESULT_API_LINK_ENTITY_BANK_ACCOUNT,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }

  getUnavailabilityListOfEntity(entityHash: any, serviceType: any) {
    let date = new Date();
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
        currentDate: this.formatDate(date.toLocaleDateString()),
        serviceType: serviceType,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_UNAVAILABILITY_LIST_OF_ENTITY}`,
      SM_CONSTANTS.RESULT_API_GET_UNAVAILABILITY_LIST_OF_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  setUnavailabilityForEntity(bodydata: any, entityHash: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_UNAVAILABILITY_FOR_ENTITY}` +
        "?entityHash=" +
        entityHash,
      SM_CONSTANTS.RESULT_API_SET_UNAVAILABILITY_FOR_ENTITY,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  removeUnavailabilityForEntity(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_REMOVE_UNAVAILABILITY_FOR_ENTITY}`,
      SM_CONSTANTS.RESULT_API_REMOVE_UNAVAILABILITY_FOR_ENTITY,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }

  getServicePaymentLinkForEntityInvoice(invoice_hash: any, entity_hash: any) {
    let date = new Date();
    const headerData: IHttpHeader[] = [
      {
        invoice_hash: invoice_hash,
        current_date: this.formatDate(date.toLocaleDateString()),
        entity_hash: entity_hash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_SERVICE_PAYMENT_LINK_FOR_ENTITY_INVOICE}`,
      SM_CONSTANTS.RESULT_API_GET_SERVICE_PAYMENT_LINK_FOR_ENTITY_INVOICE,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getCustomerListForAutoComplete(keyword: any, entity_hash: any) {
    const headerData: IHttpHeader[] = [
      {
        keyword: encodeURIComponent(keyword),
        entityHash: entity_hash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_CUSTOMER_LIST_FOR_AUTOCOMPLETE}`,
      SM_CONSTANTS.RESULT_API_GET_CUSTOMER_LIST_FOR_AUTOCOMPLETE,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  unlinkBankAccountFromBusiness(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_UNLINK_BANK_ACCOUNT_FROM_BUSINESS}`,
      SM_CONSTANTS.RESULT_API_UNLINK_BANK_ACCOUNT_FROM_BUSINESS,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  updateVirtualMeetingDetails(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_VIRTUAL_MEETING_DATA}`,
      SM_CONSTANTS.RESULT_API_UPDATE_VIRTUAL_MEETING_DATA,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  updateBookingNote(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_BOOKING_NOTE}`,
      SM_CONSTANTS.RESULT_API_UPDATE_BOOKING_NOTE,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  recordPurchasePayment(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_RECORD_PURCHASE_PAYMENT}`,
      SM_CONSTANTS.RESULT_API_RECORD_PURCHASE_PAYMENT,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  sendEmailVerificationLink(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._userServiceBaseUrl}/${SM_CONSTANTS.API_SEND_EMAIL_VERIFICATION_LINK}`,
      SM_CONSTANTS.RESULT_API_SEND_EMAIL_VERIFICATION_LINK,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }

  getInternationalEntityBankInfo(entity_hash: any) {
    const headerData: IHttpHeader[] = [
      {
        account_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        entity_hash: entity_hash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_ENTITY_BANK_INFO}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_BANK_INFO,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  enableInternationalOnlinePayments(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ENABLE_INTERNATIONAL_ONLINE_PAYMENTS}`,
      SM_CONSTANTS.RESULT_API_ENABLE_INTERNATIONAL_ONLINE_PAYMENTS,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  createPaypalPartnerAccount(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_CREATE_PAYPAL_PARTNER_ACCOUNT}`,
      SM_CONSTANTS.RESULT_API_CREATE_PAYPAL_PARTNER_ACCOUNT,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  updatePaypalSellerAccountDetails(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_PAYPAL_SELLER_ACCOUNT_DETAILS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_PAYPAL_SELLER_ACCOUNT_DETAILS,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  linkInternationalEntityBankAccount(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_LINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT}`,
      SM_CONSTANTS.RESULT_API_LINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  unlinkBankAccountFromInternationalBusiness(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_UNLINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT}`,
      SM_CONSTANTS.RESULT_API_UNLINK_INTERNATIONAL_ENTITY_BANK_ACCOUNT,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }

  getInternationalEntityAllServicePayments(
    businessHashId: any,
    fromDate: any,
    toDate: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        businessHashId: businessHashId,
        fromDate: fromDate,
        toDate: toDate,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_INTERNATIONAL_ENTITY_ALL_SERVICE_PAYMENT}`,
      SM_CONSTANTS.RESULT_API_GET_INTERNATIONAL_ENTITY_ALL_SERVICE_PAYMENT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getMemberSessionDetails(memberHash: any, weekday: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData: IHttpHeader[] = [
      {
        currentDate: currentDate,
        weekday: weekday,
        memberHash: memberHash,
        employeeHash: localStorage.getItem(
          SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
        )!,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_MEMBER_SESSION_DETAILS}`,
      SM_CONSTANTS.RESULT_API_GET_MEMBER_SESSION_DETAILS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getEntityExternalCampaignList(entityHash: any, pageNo: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
        pageNo: pageNo,
        count: "500",
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_WHATSAPP_CAMPAIGN_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_WHATSAPP_CAMPAIGN_LIST,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEntityWhatsAppCampaignTargets(campaignHash: any) {
    const headerData: IHttpHeader[] = [
      {
        campaignHash: campaignHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_WHATSAPP_CAMPAIGN_TARGETS}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_WHATSAPP_CAMPAIGN_TARGETS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getAllEnrollOpenInterestByEntityId(entityHash: any, pageNo: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
        pageNo: pageNo,
        count: "25",
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ALL_ENROLL_OPEN_INTEREST_BY_ENTITY_ID}`,
      SM_CONSTANTS.RESULT_API_GET_ALL_ENROLL_OPEN_INTEREST_BY_ENTITY_ID,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  addEditEntityExternalCampaign(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ENTITY_WHATSAPP_CAMPAIGN}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_WHATSAPP_CAMPAIGN,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  deleteEntityExternalCampaign(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_ENTITY_WHATSAPP_CAMPAIGN}`,
      SM_CONSTANTS.RESULT_API_DELETE_ENTITY_WHATSAPP_CAMPAIGN,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  syncLatestPayPalData(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_SYNC_LATEST_PAYPAL_DATA}`,
      SM_CONSTANTS.RESULT_API_SYNC_LATEST_PAYPAL_DATA,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  createInternationalSubscriptionOrder(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_CREATE_INTERNATIONAL_SUBSCRIPTION_ORDER}`,
      SM_CONSTANTS.RESULT_API_CREATE_INTERNATIONAL_SUBSCRIPTION_ORDER,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  captureInternationalSubscriptionOrderRequest(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_CAPTURE_INTERNATIONAL_SUBSCRIPTION_ORDER_REQUEST}`,
      SM_CONSTANTS.RESULT_API_CAPTURE_INTERNATIONAL_SUBSCRIPTION_ORDER_REQUEST,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }

  getEmployeeListWithAssignment(entityHash: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData: IHttpHeader[] = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        entityHash: entityHash,
        sendAll: "0",
        currentDate: currentDate,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_EMPLOYEE_LIST_WITH_ASSIGNMENT}`,
      SM_CONSTANTS.RESULT_API_GET_EMPLOYEE_LIST_WITH_ASSIGNMENT,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEntityFavouritesList(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_FAVOURITES_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_FAVOURITES_LIST,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getPostCreateEligibility(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        hash_id: entityHash,
        post_type: "2",
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._socialServiceBaseUrl}/${SM_CONSTANTS.API_GET_POST_CREATE_ELIGIBILITY}`,
      SM_CONSTANTS.RESULT_API_GET_POST_CREATE_ELIGIBILITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getProgressTrackersForMember(memberHash: any) {
    const headerData: IHttpHeader[] = [
      {
        memberHash: memberHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_PROGRESS_TRACKERS_FOR_MEMBER}`,
      SM_CONSTANTS.RESULT_API_GET_PROGRESS_TRACKERS_FOR_MEMBER,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  addEditProgressTracker(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_PROGRESS_TRACKER}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_PROGRESS_TRACKER,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  addEditProgressData(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_PROGRESS_DATA}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_PROGRESS_DATA,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }

  getProgressDataByTracker(trackerHash: any) {
    const headerData: IHttpHeader[] = [
      {
        trackerHash: trackerHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_PROGRESS_DATA_BY_TRACKER}`,
      SM_CONSTANTS.RESULT_API_GET_PROGRESS_DATA_BY_TRACKER,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  createRazorPaySubMerchantAccount(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_CREATE_RAZORPAY_SUB_MERCHANT_ACCOUNT}`,
      SM_CONSTANTS.RESULT_API_CREATE_RAZORPAY_SUB_MERCHANT_ACCOUNT,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  updateRazorPaySubMerchantAccountDetails(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_RAZORPAY_SUB_MERCHANT_ACCOUNT_DETAILS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_RAZORPAY_SUB_MERCHANT_ACCOUNT_DETAILS,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  linkDomesticEntityBankAccount(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_LINK_DOMESTIC_ENTITY_BANK_ACCOUNT}`,
      SM_CONSTANTS.RESULT_API_LINK_DOMESTIC_ENTITY_BANK_ACCOUNT,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }

  getDomesticEntityBankInfo(entity_hash: any) {
    const headerData: IHttpHeader[] = [
      {
        entity_hash: entity_hash,
        account_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_DOMESTIC_ENTITY_BANK_INFO}`,
      SM_CONSTANTS.RESULT_API_GET_DOMESTIC_ENTITY_BANK_INFO,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getWhatsAppEmailQuotaAndUsage(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_WHATSAPP_EMAIL_QUOTA_USAGE}`,
      SM_CONSTANTS.RESULT_API_GET_WHATSAPP_EMAIL_QUOTA_USAGE,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getMemberAutoInvoiceSendingSettings(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS}`,
      SM_CONSTANTS.RESULT_API_GET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getFunctionalityByEmployeeId(employeeHash: any) {
    const headerData: IHttpHeader[] = [
      {
        employeeHash: employeeHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_FUNCTIONALITY_BY_EMPLOYEE_ID}`,
      SM_CONSTANTS.RESULT_API_GET_FUNCTIONALITY_BY_EMPLOYEE_ID,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  updateEmployeeFunctionalityAccessStatus(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_EMPLOYEE_FUNCTIONALITY_ACCESS_STATUS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_EMPLOYEE_FUNCTIONALITY_ACCESS_STATUS,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  setMemberAutoInvoiceSendingSettings(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS}`,
      SM_CONSTANTS.RESULT_API_SET_MEMBER_AUTO_INVOICE_SENDING_SETTINGS,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }
  getBookingAdvancePaymentSettings(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_BOOKING_ADVANCE_PAYMENT_SETTINGS}`,
      SM_CONSTANTS.RESULT_API_GET_BOOKING_ADVANCE_PAYMENT_SETTINGS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  setBookingAdvancePaymentSettings(bodydata: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_BOOKING_ADVANCE_PAYMENT_SETTINGS}`,
      SM_CONSTANTS.RESULT_API_SET_BOOKING_ADVANCE_PAYMENT_SETTINGS,
    );
    apiParam.body = bodydata;
    this.apiHandler(apiParam);
  }

  addEditEntityAdvanceInvoice(bodyData: any) {
    const headerData = [
      {
        creatorAccountHash: localStorage.getItem(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        )!,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_ENTITY_ADVANCE_INVOICE}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_ADVANCE_INVOICE,
      bodyData,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  addEditInternationalEntityAdvanceInvoice(bodyData: any) {
    const headerData = [
      {
        creatorAccountHash: localStorage.getItem(
          SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
        )!,
      },
    ];
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_ADD_EDIT_INTERNATIONAL_ENTITY_ADVANCE_INVOICE}`,
      SM_CONSTANTS.RESULT_API_ADD_EDIT_INTERNATIONAL_ENTITY_ADVANCE_INVOICE,
      bodyData,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  cancelEntityAppointmentData(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_CANCEL_ENTITY_APPOINTMENT_DATA}`,
      SM_CONSTANTS.RESULT_API_CANCEL_ENTITY_APPOINTMENT_DATA,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getWalletMoneyForEntityCustomer(
    entityPublicHash: any,
    countryCode: any,
    phone: any,
  ) {
    let url =
      this._transactionServiceBaseUrl +
      "/" +
      SM_CONSTANTS.API_GET_WALLET_MONEY_FOR_ENTITY_CUSTOMER +
      "?entityPublicHash=" +
      entityPublicHash +
      "&countryCode=" +
      encodeURIComponent(countryCode) +
      "&phone=" +
      phone;
    return this._httpClient.get<any>(url);
  }

  getUserTotalWalletAmountForEntity(
    entityHash: any,
    countryCode: any,
    phone: any,
  ) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
        phone: phone,
        currentDate: currentDate,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_USER_TOTAL_WALLET_AMOUNT_FOR_ENTITY}` +
        "?countryCode=" +
        encodeURIComponent(countryCode),
      SM_CONSTANTS.RESULT_API_GET_USER_TOTAL_WALLET_AMOUNT_FOR_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getUserWalletTransactionsListForEntity(
    entityHash: any,
    countryCode: any,
    phone: any,
    pageNo: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
        phone: phone,
        count: "500",
        pageNo: pageNo,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_USER_WALLET_TRANSACTIONS_LIST_FOR_ENTITY}` +
        "?countryCode=" +
        encodeURIComponent(countryCode),
      SM_CONSTANTS.RESULT_API_GET_USER_WALLET_TRANSACTIONS_LIST_FOR_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  addTransactionToWallet(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_ADD_TRANSACTION_TO_WALLET}`,
      SM_CONSTANTS.RESULT_API_ADD_TRANSACTION_TO_WALLET,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  updateWalletRefundStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_WALLET_REFUND_STATUS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_WALLET_REFUND_STATUS,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  deleteWalletTransaction(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_DELETE_WALLET_TRANSACTION}`,
      SM_CONSTANTS.RESULT_API_DELETE_WALLET_TRANSACTION,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  updateEnityEnquiryProgressStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_UPDATE_ENTITY_ENQUIRY_PROGRESS_STATUS}`,
      SM_CONSTANTS.RESULT_API_UPDATE_ENTITY_ENQUIRY_PROGRESS_STATUS,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  getEntityEnquiryDetails(hashId: any) {
    const headerData: IHttpHeader[] = [
      {
        hashId: hashId,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_ENQUIRY_DETAILS}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_ENQUIRY_DETAILS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getEntityEnquiryList(
    entityHash: any,
    fromDate: any,
    toDate: any,
    serviceMode: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
        fromDate: fromDate,
        toDate: toDate,
        serviceMode: serviceMode,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._commonServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_ENQUIRY_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_ENQUIRY_LIST,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  editMemberServiceProductOtherData(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_EDIT_MEMBER_SERVICE_PRODUCT_OTHER_DATA}`,
      SM_CONSTANTS.RESULT_API_EDIT_MEMBER_SERVICE_PRODUCT_OTHER_DATA,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  editMemberTimingsData(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_EDIT_MEMBER_TIMINGS_DATA}`,
      SM_CONSTANTS.RESULT_API_EDIT_MEMBER_TIMINGS_DATA,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  editMemberPersonalDetails(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_EDIT_MEMBER_PERSONAL_DETAILS}`,
      SM_CONSTANTS.RESULT_API_EDIT_MEMBER_PERSONAL_DETAILS,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getEntityAllEnquiryList(entityHash: any, pageNo: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
        pageNo: pageNo,
        count: "25",
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_ALL_ENQUIRY_LIST}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_ALL_ENQUIRY_LIST,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  setEntityLoyaltyConfiguration(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_ENTITY_LOYALTY_CONFIGURATION}`,
      SM_CONSTANTS.RESULT_API_SET_ENTITY_LOYALTY_CONFIGURATION,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  setEntityBookingLoyaltyConfiguration(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_ENTITY_BOOKING_LOYALTY_CONFIGURATION}`,
      SM_CONSTANTS.RESULT_API_SET_ENTITY_BOOKING_LOYALTY_CONFIGURATION,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  setEntityPaymentLoyaltyConfiguration(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_ENTITY_PAYMENT_LOYALTY_CONFIGURATION}`,
      SM_CONSTANTS.RESULT_API_SET_ENTITY_PAYMENT_LOYALTY_CONFIGURATION,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  setEntityReferralLoyaltyConfiguration(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_ENTITY_REFERRAL_LOYALTY_CONFIGURATION}`,
      SM_CONSTANTS.RESULT_API_SET_ENTITY_REFERRAL_LOYALTY_CONFIGURATION,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  getEntityLoyaltyConfiguration(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_ENTITY_LOYALTY_CONFIGURATION}`,
      SM_CONSTANTS.RESULT_API_GET_ENTITY_LOYALTY_CONFIGURATION,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  setRewardPountConversionForEntity(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_REWARD_POINT_CONVERSION_FOR_ENTITY}`,
      SM_CONSTANTS.RESULT_API_SET_REWARD_POINT_CONVERSION_FOR_ENTITY,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  getRewardPountConversionForEntity(entityHash: any) {
    const headerData: IHttpHeader[] = [
      {
        enttityHash: entityHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_REWARD_POINT_CONVERSION_FOR_ENTITY}`,
      SM_CONSTANTS.RESULT_API_GET_REWARD_POINT_CONVERSION_FOR_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getUserTotalRewardAmountForEntity(
    entityHash: any,
    countryCode: any,
    phone: any,
  ) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
        phone: phone,
        currentDate: currentDate,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_USER_TOTAL_REWARD_AMOUNT_FOR_ENTITY}` +
        "?countryCode=" +
        encodeURIComponent(countryCode),
      SM_CONSTANTS.RESULT_API_GET_USER_TOTAL_REWARD_AMOUNT_FOR_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  getUserRewardTransactionsListForEntity(
    entityHash: any,
    countryCode: any,
    phone: any,
    pageNo: any,
  ) {
    const headerData: IHttpHeader[] = [
      {
        entityHash: entityHash,
        phone: phone,
        count: "500",
        pageNo: pageNo,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_GET_USER_REWARD_TRANSACTION_LIST_FOR_ENTITY}` +
        "?countryCode=" +
        encodeURIComponent(countryCode),
      SM_CONSTANTS.RESULT_API_GET_USER_REWARD_TRANSACTION_LIST_FOR_ENTITY,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  refundPaymentToCustomer(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_REFUND_PAYMENT_TO_CUSTOMER}`,
      SM_CONSTANTS.RESULT_API_REFUND_PAYMENT_TO_CUSTOMER,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  setEntityMembershipLoyaltyConfiguration(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_ENTITY_MEMBERSHIP_LOYALTY_CONFIGURATION}`,
      SM_CONSTANTS.RESULT_API_SET_ENTITY_MEMBERSHIP_LOYALTY_CONFIGURATION,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  transferRewardsToWallet(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._transactionServiceBaseUrl}/${SM_CONSTANTS.API_TRANSFER_REWARDS_TO_WALLET}`,
      SM_CONSTANTS.RESULT_API_TRANSFER_REWARDS_TO_WALLET,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getLatestUnpaidInvoiceStatusForDashboard(pageNo: any, count: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());
    const headerData = [
      {
        accountHash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)!,
        currentDate: currentDate,
        count: count,
        pageNo: pageNo,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_LATEST_UNPAID_INVOICE_STATUS_FOR_DASHBOARD}`,
      SM_CONSTANTS.RESULT_API_GET_LATEST_UNPAID_INVOICE_STATUS_FOR_DASHBOARD,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

  setEntityPublicPostPermissionStatus(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_ENTITY_PUBLIC_POST_PERMISSION_STATUS}`,
      SM_CONSTANTS.RESULT_API_SET_ENTITY_PUBLIC_POST_PERMISSION_STATUS,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  getPublicPostingPermissionStatus(entityHash: any) {
    const headerData = [
      {
        entityHash: entityHash,
      },
    ];

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_PUBLIC_POSTING_PERMISSION_STATUS}`,
      SM_CONSTANTS.RESULT_API_GET_PUBLIC_POSTING_PERMISSION_STATUS,
    );
    apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }
  getCustomerDetails(entityHash: any, countryCode: any, phone: any, name: any) {
    const date = new Date();
    const currentDate = this.formatDate(date.toLocaleDateString());

    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_GET,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_GET_CUSTOMER_DETAILS}` +
        "?entityHash=" +
        entityHash +
        "&countryCode=" +
        encodeURIComponent(countryCode) +
        "&phone=" +
        phone + 
        "&name=" + 
        name + 
        "&currentDate=" + 
        currentDate,
      SM_CONSTANTS.RESULT_API_GET_CUSTOMER_DETAILS,
    );
    // apiParam.httpParam = this.composeHttpParam(headerData);
    this.apiHandler(apiParam);
  }

    requestEntityDomainMapping(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_REQUEST_ENTITY_DOMAIN_MAPPING}`,
      SM_CONSTANTS.RESULT_API_REQUEST_ENTITY_DOMAIN_MAPPING,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  setBusinessSocialLinks(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SET_BUSINESS_SOCIAL_LINKS}`,
      SM_CONSTANTS.RESULT_API_SET_BUSINESS_SOCIAL_LINKS,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  sendReviewRequestViaEmail(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SEND_REVIEW_REQUEST_VIA_EMAIL}`,
      SM_CONSTANTS.RESULT_API_SEND_REVIEW_REQUEST_VIA_EMAIL,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  sendPaymentIntimaionViaEmail(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SEND_PAYMENT_INTIMATION_VIA_EMAIL}`,
      SM_CONSTANTS.RESULT_API_SEND_PAYMENT_INTIMATION_VIA_EMAIL,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  sendReviewRequestViaWhatsApp(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SEND_REVIEW_REQUEST_VIA_WHATSAPP}`,
      SM_CONSTANTS.RESULT_API_SEND_REVIEW_REQUEST_VIA_WHATSAPP,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  sendPaymentIntimationViaWhatsApp(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_SEND_PAYMENT_INTIMATION_VIA_WHATSAPP}`,
      SM_CONSTANTS.RESULT_API_SEND_PAYMENT_INTIMATION_VIA_WHATSAPP,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  editMemberAddress(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_EDIT_MEMBER_ADDRESS}`,
      SM_CONSTANTS.RESULT_API_EDIT_MEMBER_ADDRESS,
      bodyData,
    );
    this.apiHandler(apiParam);
  }
  editMemberVirtualSessionInfo(bodyData: any) {
    const apiParam = new HttpMethodArgs(
      SM_CONSTANTS.REQUEST_POST,
      `${this._businessServiceBaseUrl}/${SM_CONSTANTS.API_EDIT_MEMBER_VIRTUAL_SESSION_INFO}`,
      SM_CONSTANTS.RESULT_API_EDIT_MEMBER_VIRTUAL_SESSION_INFO,
      bodyData,
    );
    this.apiHandler(apiParam);
  }

  //-----------------------    API HANDLERS    -----------------------//

  private composeHttpHeader(headerObjs: { [header: string]: string }[]) {
    let httpHeader: HttpHeaders = new HttpHeaders();
    httpHeader = httpHeader.set("Content-type", "application/json");
    headerObjs.forEach((obj) => {
      for (const [key, val] of Object.entries(obj)) {
        httpHeader = httpHeader.set(key, val);
      }
    });
    // console.log(httpHeader);
    return httpHeader;
  }

  private composeHttpParam(paramObjs: { [key: string]: string }[]) {
    let httpParam: HttpParams = new HttpParams();

    paramObjs.forEach((obj) => {
      for (const [key, val] of Object.entries(obj)) {
        httpParam = httpParam.append(key, val);
      }
    });
    return httpParam;
  }

  private apiHandler(apiData: HttpMethodArgs) {
    switch (apiData.methodType) {
      case SM_CONSTANTS.REQUEST_GET:
        this._httpClient
          .get<any>(apiData.apiEndpoint, {
            headers: apiData.httpHeader,
            params: apiData.httpParam,
          })
          .pipe(catchError((err) => this.errorHandler(err, apiData.resultType)))
          .subscribe((res) => {
            console.log(res);
            this._apiResult.next({
              result: res,
              responseType: apiData.resultType,
              otherData: apiData.extraData,
            });
          });
        break;

      case SM_CONSTANTS.REQUEST_POST:
        this._httpClient
          .post<any>(apiData.apiEndpoint, apiData.body, {
            headers: apiData.httpHeader,
            params: apiData.httpParam,
          })
          .pipe(
            map((value) => {
              if (value?.errorcode) {
                value.errorcode = +value.errorcode;
              }
              return value;
            }),
            catchError((err) => this.errorHandler(err, apiData.resultType)),
          )
          .subscribe((res) => {
            // console.log(res);
            this._apiResult.next({
              result: res,
              responseType: apiData.resultType,
              otherData: apiData.extraData,
            });
          });

        break;

      case SM_CONSTANTS.REQUEST_PUT:
      case SM_CONSTANTS.REQUEST_GET:
        this._httpClient
          .put<any>(apiData.apiEndpoint, apiData.body, {
            headers: apiData.httpHeader,
            params: apiData.httpParam,
          })
          .pipe(catchError((err) => this.errorHandler(err, apiData.resultType)))
          .subscribe((res) => {
            console.log(res);
            this._apiResult.next({
              result: res,
              responseType: apiData.resultType,
              otherData: apiData.extraData,
            });
          });
        break;

      default:
        break;
    }
  }
  private errorHandler(error: HttpErrorResponse, resulttype: any) {
    console.log(error);
    console.log(resulttype);
    this._errorResponse.next({ error: error.error, message: error.message });
    return throwError(error);
  }

  get apiResult() {
    return this._apiResult.asObservable();
  }

  get errorResponse() {
    return this._errorResponse.asObservable();
  }

  formatDate(dateStr: string) {
    // let curdate = new Date().toISOString().slice(0,10);
    // return curdate;

    let curdate = new Date()
      .toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .slice(0, 10);

    return curdate;

    // // Split the date string by `/`
    // const parts = dateStr.split('/');

    // // Reverse the order of the parts and join them with `-`
    // const newDateStr = parts.reverse().join('-');

    // // Return the formatted date string
    // return newDateStr;
  }

  formatDateString(): string {
    const now = new Date();

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options,
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
